import { CircularProgress, List, makeStyles, PlaceholderBookingTemplateIcon, Theme } from '@freighthub/silhouette-core'
import { FC, MouseEvent, useContext } from 'react'
import { useI18n } from 'utils/localisation'

import { IBookingTemplate } from '../BookingTemplate'
import { EmptyViewWithIcon } from '../EmptyViewWithIcon'
import { BookingTemplatesListItem } from './BookingTemplatesListItem'
import { NewQuoteButtonContext } from './NewQuoteButtonContext'

export const testIds = {
  loader: 'booking-templates-list-loader',
  empty: 'booking-templates-list-empty',
  list: 'booking-templates-list-root',
}

export interface BookingTemplatesListProps {
  onClickItem: () => void
}

const useStyles = makeStyles<Theme>(() => ({
  list: {
    height: '100%',
    width: '100%',
  },
}))

export const BookingTemplatesList: FC<BookingTemplatesListProps> = ({ onClickItem }) => {
  const classes = useStyles({})
  const { translate } = useI18n()
  const { bookingTemplates, isLoading, dispatch } = useContext(NewQuoteButtonContext)

  const handleClickItem = (_event: MouseEvent<HTMLDivElement>, template: IBookingTemplate) => {
    // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    dispatch({ type: 'openRequestDialog', template })
    onClickItem()
  }

  if (isLoading) {
    return <CircularProgress data-testid={testIds.loader} />
  }

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  if (bookingTemplates.length === 0) {
    return (
      <EmptyViewWithIcon
        icon={<PlaceholderBookingTemplateIcon />}
        text={translate('recent_booking_templates-no_templates')}
        data-testid={testIds.empty}
      />
    )
  }

  return (
    <List className={classes.list} disablePadding data-testid={testIds.list}>
      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
      {bookingTemplates.map((template) => (
        <BookingTemplatesListItem key={template._id} template={template} onClick={handleClickItem} />
      ))}
    </List>
  )
}
